import { useResetPasswordMutation } from "@mc-intranet/shared";
import { LoadingButton } from "@mui/lab";
import { Box, Container, FormHelperText, Grid, Link } from "@mui/material";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { useGraphQLClient } from "../../cache";
import { PasswordField } from "../../components/ui/PasswordField";

type FormData = {
  password: string;
  passwordConfirmation: string;
};
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
  // loading: boolean;
  // login: (userName: string, password: string) => void;
}
interface ParamTypes {
  code: string;
}
const ResetPasswordPage: React.FC<Props> = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  const {
    control,
    formState: { errors },
    handleSubmit,
    watch
  } = useForm<FormData>({
    defaultValues: {
      password: "",
      passwordConfirmation: ""
    }
  });

  const { client } = useGraphQLClient();

  const {
    mutate: resetPasswordMutation,
    isLoading: loading,
    isError: mutationError
  } = useResetPasswordMutation(client);

  const onSubmit = (values: FormData) => {
    console.log("Success:", values);
    const { password, passwordConfirmation } = values;

    resetPasswordMutation(
      {
        password,
        passwordConfirmation,
        code: code ?? ""
      },
      {
        onSuccess: (data) => {
          if (data?.resetPassword) {
            console.log("resetPassword", data?.resetPassword);
            toast.success("Password impostata correttamente", {
              position: toast.POSITION.TOP_CENTER
            });
            navigate("/");
          } else {
            console.log("errors");
            return;
          }
          // const { user, jwt } = resetPassword;
        },
        onError: (error: any) => {
          toast.error(error?.response?.error.message, {
            position: toast.POSITION.TOP_CENTER
          });
        }
      }
    );
  };
  // console.log("mutationError", mutationError);
  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: {
          xs: "calc(100vh - 56px - 56px)",
          md: "calc(100vh - 69px - 56px)"
        },
        position: "relative"
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        width="100%"
      >
        <Controller
          name="password"
          control={control}
          rules={{
            required: "campo obbligatorio"
          }}
          render={({ field }) => (
            <PasswordField
              label="Password"
              error={errors.password as any}
              {...field}
            />
          )}
        />
        <Controller
          name="passwordConfirmation"
          control={control}
          rules={{
            required: "campo obbligatorio",
            validate: (value) =>
              value === watch("password") ? true : "Passwords devono coincidere"
          }}
          render={({ field }) => (
            <PasswordField
              label="Ripeti Password"
              error={errors.passwordConfirmation as any}
              {...field}
            />
          )}
        />
        <LoadingButton
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          loading={loading}
        >
          Reset
        </LoadingButton>
        <Grid container>
          <Grid item xs>
            <Link component={RouterLink} to="/" variant="body2">
              Back to login
            </Link>
          </Grid>
          {/* <Grid item>
                  <Link href="#" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </Link>
                </Grid> */}
        </Grid>
        {mutationError && (
          <FormHelperText error>Error :( Riprova</FormHelperText>
        )}
      </Box>
    </Container>
  );
};

export default ResetPasswordPage;
